import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import usePageStore from '../Page/pageStore';
import { useLocation } from 'react-router-dom';
import { getPath } from '../Router/Router';
import { editorSlug, homePath } from '../globalUtils';
const BackgroundSwitch = ({ children }) => {
    const urlPath = useLocation().pathname;
    const { shownPage } = usePageStore();
    const allowed = getPath(urlPath) === homePath ||
        shownPage === homePath ||
        getPath(urlPath) === editorSlug;
    return allowed ? _jsx(_Fragment, { children: children }) : null;
};
export default BackgroundSwitch;
